import { useState } from 'react';
import { isMetaSafeConnectEligible } from 'app/modules/socialLogin/utils';
import { SocialLoginTokenType } from 'types/SocialLogin';

type View = 'network' | 'tokenType';

const useMetaTokenTypeStep = (
  onProceedUser: (pageType: number, tokenType?: SocialLoginTokenType) => void,
  initialPageType?: number | null,
) => {
  const isInitialMetaNetwork = isMetaSafeConnectEligible(initialPageType);
  const [view, setView] = useState<View>(
    isInitialMetaNetwork ? 'tokenType' : 'network',
  );
  const [selectedPageType, setSelectedPageType] = useState<number | null>(
    isInitialMetaNetwork ? initialPageType ?? null : null,
  );

  const handleSelectNetwork = (pageType: number) => {
    if (isMetaSafeConnectEligible(pageType)) {
      setSelectedPageType(pageType);
      setView('tokenType');
      return;
    }

    onProceedUser(pageType);
  };

  const handleSelectPersonal = () => {
    if (selectedPageType !== null) {
      onProceedUser(selectedPageType, 'user');
    }
  };

  const reset = () => {
    setView('network');
    setSelectedPageType(null);
  };

  return {
    view,
    selectedPageType,
    isChoosingTokenType: view === 'tokenType',
    handleSelectNetwork,
    handleSelectPersonal,
    reset,
  };
};

export default useMetaTokenTypeStep;
